module.exports = __webpack_public_path__ + "img/1_029.756ccd18.jpg";